<template>
  <div class="menuBody" style="margin-left:25px;">
    <div class="menuTool" style="width:100%;">
        <!-- <pollingTree @pollingTree="getMsgFormSon" /> -->
         <PollingTaskDialog @dialogVisible="dialog"  ref="PollingTaskDialog"/>
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                巡检任务列表
              <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" @click="PropertyAdd()">巡检任务添加</el-button>
            </div>
            </div>
               <div style="width:150px;float:left;margin-right:15px">
                <el-select  clearable v-model="value" @change="classificationChange(value)" placeholder="请选择巡检分类">
                    <el-option
                    v-for="item in classificationList"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id">
                    </el-option>
                </el-select>
              </div>
             <div style="float:right;margin-right:15px;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" @click="Inquire()">查询</el-button>
            </div>
    <el-table  :data="tableData" tooltip-effect="light"  v-loading="loading" style="margin-bottom: 20px;overflow-y: scroll;float:right;margin-top:30px" row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
        <el-table-column show-overflow-tooltip prop="inspectType" label="巡检分类"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="inspectRateNum" label="频次"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="field" label="天数" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="inspectRate" label="计划周期" >
           <template slot-scope="scope">
            <el-tag v-if="scope.row.inspectRate=='seasons'">季度</el-tag>
            <el-tag v-if="scope.row.inspectRate=='week'">周</el-tag>
            <el-tag v-if="scope.row.inspectRate=='month'">月</el-tag>
            <el-tag v-if="scope.row.inspectRate=='year'">年</el-tag>
            <el-tag v-if="scope.row.inspectRate=='day'">日</el-tag>
          </template>          
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createDateTime" label="创建时间" ></el-table-column>
        <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
            <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" title="修改"></el-button>
            <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" title="删除"  v-debounce></el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import PollingTaskDialog from '../pollingCommon/PollingTaskDialog.vue'
import pollingTree from "../pollingCommon/pollingTree.vue";
export default {
  name: "PollingTask",
  components: {PollingTaskDialog,pollingTree},
  data() {
    return {
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        loading:false,
        classifyName:"",
        tableData:[],
        classificationList:[{
            "value":"1",
            "label":"工程巡检"
        }],
        value:"",
        InodeCode:"",
        orgId:"",
    }
  },
  methods: {
    handleSizeChange(val) {
        this.pagesize  = val
        this.InitialQuery()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.InitialQuery()
    },
    InitialQuery(){
    // 列表
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "inspectType":"",
      }
        this.$http.post(this.$requestUrl.POST_TASK_LIST,PageSize).then((res) => {
          let data = res.data
          if(data.code == 200){
            for(let val of data.data.records){
              val.createDate=val.createDate.replace('T',' ')
              val.createDateTime = val.createDate.substr(0,val.createDate.length-9)
            }
            this.tableData = data.data.records
            this.total = data.data.total
          }else{
            this.$message.error(data.msg)
          }
        }).catch(() => {
              this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    PropertyAdd(){
    // 添加
        let obj = {}
        this.$refs.PollingTaskDialog.title = "添加巡检任务";
        this.$refs.PollingTaskDialog.dialogVisible = true;
        this.$refs.PollingTaskDialog.formLabelAlign = obj
        this.$refs.PollingTaskDialog.SubordinateList=this.classificationList
        this.$refs.PollingTaskDialog.DutyCycleList = this.dutyDate
        this.$refs.PollingTaskDialog.value = ""
        this.$refs.PollingTaskDialog.DutyCyclevalue = ""
    },
    editMenu(row){
    // 修改
        this.$refs.PollingTaskDialog.title = "修改巡检任务";
        this.$refs.PollingTaskDialog.dialogVisible = true;
        this.$refs.PollingTaskDialog.formLabelAlign = row
        this.$refs.PollingTaskDialog.SubordinateList=this.classificationList
        this.$refs.PollingTaskDialog.DutyCycleList = this.dutyDate
        this.$refs.PollingTaskDialog.value = row.inspectType
        this.$refs.PollingTaskDialog.DutyCyclevalue = row.inspectRate
    },
    delMenu(row){
    // 删除
      this.$confirm('是否确认要删除该检查项目?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.get(this.$requestUrl.DELETE_TASK+row.id).then((res) => {
          let data = res.data
          if(data.code == 200){
            this.currentPage = 1
            this.InitialQuery()
            }else{
              this.$message.error(data.msg)
            }
            })
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });  
    },
    Inquire(){
    let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "inspectType":this.inspectType,
      }
    this.$http.post(this.$requestUrl.POST_TASK_LIST,PageSize).then((res) => {
      let data = res.data
      if(data.code == 200){
        for(let val of data.data.records){
          val.createDate=val.createDate.replace('T',' ')
          val.createDateTime = val.createDate.substr(0,val.createDate.length-9)
        }
        this.tableData = data.data.records
        this.total = data.data.total
        this.inspectType = ""
      }else{
         this.$message.error(data.msg)
      }
    }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
    })
    },
    classification(){
      this.$http.get("/inspect/type/select").then((res)=>{
      let data = res.data
      if(data.code == 200){
        this.classificationList = res.data.data
      }else{
        this.$message.error(data.msg)
      }
      })
    },
    classificationChange(res){
      for(let val of this.classificationList){
        if(res == val.id){
          this.inspectType = val.typeName
        }
      }
    },
    period(){
     this.$http.get("/inspect/project/getRate").then((res)=>{
      let data = res.data
      if(data.code == 200){
        var words = res.data.data
        var result = Object.keys(words).map(e => ({value: e, label: words[e]}))
        this.dutyDate = result
      }else{
        this.$message.error(data.msg)
      }
      })
    },
    // getMsgFormSon(data){
    //          if(data.orgId == null){
    //     this.orgId = data.id
    //   }else{
    //     this.orgId = data.orgId
    //   }
    // },
    dialog(data){
      if(data==false){
        this.InitialQuery()
      }
    },





  },
  mounted() {
      this.InitialQuery()
      this.period()
      this.classification()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
</style>